var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    class: _vm.toolbarColor,
    attrs: {
      "dark": "",
      "dense": ""
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.toolbarLogo
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "hidden-xs-and-down"
  }, [_vm._v("\n    " + _vm._s(_vm.toolbarTitle) + "\n  ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.$store.state.isRunningEmbedded) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: (_vm.toolTipMinimize),
      expression: "toolTipMinimize",
      arg: "left"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMinimize($event)
      }
    }
  }, [_c('v-icon', [_vm._v("\n      " + _vm._s(_vm.isUiMinimized ? 'arrow_drop_up' : 'arrow_drop_down') + "\n    ")])], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59f58ea4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToolbarContainer.vue
// module id = 157
// module chunks = 1